// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = "/auth";
const ROOTS_DASHBOARD = "/dashboard";
const ROOTS_JOBBOARD = "/job-board";
const ROOTS_EMPLOYMENT = "/employment";
const ROOT_APPRAISAL = "/appraisal";
const ROOT_PROFILE = "/profile";
const ROOT_REQUESTS = "/requests";

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  signIn: path(ROOTS_AUTH, "/sign-in"),
  signUp: path(ROOTS_AUTH, "/sign-up"),
  resetPassword: path(ROOTS_AUTH, "/reset-password"),
  verification: path(ROOTS_AUTH, "/verification"),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
};

export const PATH_EMPLOYMENT = {
  root: ROOTS_EMPLOYMENT,
};

export const PATH_REQUESTS = {
  root: ROOT_REQUESTS,
};

export const PATH_JOBBOARD = {
  root: ROOTS_JOBBOARD,
  post: path(ROOTS_JOBBOARD, "/post"),
};

export const PATH_APPRAISAL = {
  root: ROOT_APPRAISAL,
};

export const PATH_PROFILE = {
  root: ROOT_PROFILE,
  edit: path(ROOT_PROFILE, "/edit"),
};
